export default "__VITE_ASSET__DKAy0$mP__"